import React, { useEffect, useState } from "react";
import { Button, ConfigProvider, Input, Modal, Tooltip } from "antd";
import { SaveOutlined } from '@ant-design/icons';
import { getCountryCode } from "../misc_functions";
import { API_DOMAIN, country_codes } from "../constants";
import no_img from "../../assets/images/no_img.jpg"
import axios from "axios";

const CustomerAddModal = ({ openCustomerAddModal, handleCloseCustomerAddModal, cus_name_set_for_select, set_cus_name_set_for_select, reload_customers, set_phone_data, useSnackbar }) => {

    const { SuccessSnackbar, ErrorSnackbar, InfoSnackbar, WarningSnackbar, ToastContainer } = useSnackbar();

    const [customerName, setCustomerName] = useState(null);
    const [customerNumber, setCustomerNumber] = useState(null);
    const [countrycode, setCountrycode] = useState(null);
    const [save_button_loading, setSave_button_loading] = useState(false);

    const reset_inputs = () => {
        setCustomerName(null)
        setCustomerNumber(null)
        setCountrycode(null)
        setSave_button_loading(false)
    }

    const get_country_details_from_phone_number = () => {
        var _countrycode;
        try {
            _countrycode = getCountryCode(customerNumber)
            setCountrycode(_countrycode)
        } catch (error) {
            setCountrycode(error.message)
        }
    }


    useEffect(() => {
        if (customerNumber) {
            get_country_details_from_phone_number();
        }
        else {
            setCountrycode(null)
        }
    }, [customerNumber]);

    useEffect(() => {
        reload_customers();
    }, []);

    const handleCustomerSubmit = async () => {
        setSave_button_loading(true);
        try {
            if (!customerNumber) {
                WarningSnackbar(`Please enter a valid customer phone number`)
                return;
            }
            if (!customerName) {
                WarningSnackbar(`Please enter a valid customer name`)
                return;
            }
            var found_customer = cus_name_set_for_select?.find((e) => e?.value == customerNumber)
            if (found_customer) {
                InfoSnackbar(`Customer with phone number already exist!`)
                return;
            }
            const res = await axios.post(`${API_DOMAIN}/whatsapp/customer_add`, { name: customerName, number: customerNumber })
            if (res?.data?.success) {
                SuccessSnackbar(`Customer Added Successfully`);
                set_cus_name_set_for_select(prev => ([
                    ...prev,
                    { value: customerNumber, label: customerName }
                ]))
                set_phone_data(customerNumber);
                reset_inputs();
                handleCloseCustomerAddModal();
            }
            else {
                ErrorSnackbar(res?.data?.message)
            }
        } catch (error) {
            ErrorSnackbar(error?.message)
        }
        finally {
            setSave_button_loading(false);
        }
    }

    return (
        <>
            {/* wati templates showing main modal */}
            <Modal
                open={openCustomerAddModal}
                onCancel={() => { handleCloseCustomerAddModal(); reset_inputs(); }}
                centered
                maskClosable={false}
                title={
                    <div className="p-2">Add New Customer</div>
                }
                width={600}
                footer={
                    <div className="flex justify-end" >
                        <ConfigProvider
                            theme={{
                                components: {
                                    Button: {
                                        defaultHoverColor: "#ffffff",
                                        defaultColor: "#ffffff",
                                        defaultHoverBg: "#3be368",
                                        defaultBg: "#31bd56",
                                    },
                                },
                            }}
                        >
                            <Button
                                size="middle"
                                loading={save_button_loading}
                                onClick={() => handleCustomerSubmit()}
                            >
                                <SaveOutlined />
                                Save
                            </Button>
                        </ConfigProvider>
                    </div>
                }
            >
                <div className="gap-2 p-2 m-2 rounded border drop-shadow" style={{ backgroundColor: "#f7f7f7" }}>
                    <div>
                        <Input
                            allowClear
                            style={{ width: '100%' }}
                            placeholder="Customer Phone Number"
                            value={customerNumber}
                            onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(/\D/g, "")?.replace(/^05/, '9715');
                                setCustomerNumber(onlyNumbers);
                            }}
                            addonAfter={<div style={{ width: "25px", overflowX: "clip" }}>
                                <Tooltip title={country_codes[countrycode]}>
                                    {countrycode && countrycode != "TOO_SHORT" ? (
                                        <img src={"https://cdn.clare.ai/flags/" + countrycode + ".svg"} alt="Unknown" />) :
                                        (<img src={no_img} alt="Unknown" />)}
                                </Tooltip>
                            </div>}
                        />
                    </div>

                    <div className="mt-2">
                        <Input
                            allowClear
                            style={{ width: '100%' }}
                            placeholder="Customer Name"
                            value={customerName}
                            onChange={(e) => { setCustomerName(e?.target?.value) }}
                        />
                    </div>

                </div>
            </Modal >
        </>
    );
}

export default CustomerAddModal;